import { type LinearConfiguratorState } from "../redux/types";
import { type LinearConfigurationUpdate } from "../models";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";
import { prepareApiDataForResetNew, prepareGroupIdToDisplay } from "../../common/commonConfiguratorApi";

export function sendLinearDataReset(linearState: LinearConfiguratorState): Promise<LinearConfigurationUpdate> {
  const data = prepareCommonLinearData(linearState);
  // TODO: Check if reset in all steps works correctly after this change
  const resetData = prepareApiDataForResetNew(linearState);

  // For Step 7 - we need to send a special flag to reload the default values for the carriage details substep
  if (linearState.currentStep === 6) {
    data.linearConfiguratorData.resetCarriageDetails = true;
  }

  // For Step 2, we need to reset the flag that holds the section height default to "No"
  if (linearState.currentStep === 1) {
    data.linearConfiguratorData.customSectionHeightSelected = false;
  }

  // For Step 5, we need to reset the flag that remembers the customer selection for closing plugs
  if (linearState.currentStep === 4) {
    data.linearConfiguratorData.defaultPlugsApplied = false;
  }

  prepareGroupIdToDisplay(data);

  return sendLinear({
    ...data,
    ...resetData,
  });
}
